export const publicationsData = [
	{
		title:
			"Mobile Application for Real‑Time News Summarization In Indian Languages",
		description:
			"Developed an app for providing summarized news gist in multiple languages covering more than 50+ news websites and automated almost 80 percent of the task using Python, MongoDB, Docker, GCP, Flutter and Airflow.",
		publishedDate: "May 2021",
		paperURL: "http://gjstx-e.cn/gallery/73-may2021.pdf",
		codeURL: "https://github.com/sonishreyas/news_scraper",
	},
];
